import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  academicStoryLength: 0,
  academicStory: [],
}

export default function academicStoryReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_ACADEMIC_STORY:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_ACADEMIC_STORY:
      return {...state, saveLoader: action.payload}
    case actions.GET_ACADEMIC_STORY:
      return {...state, academicStory: action.payload.academicStory, academicStoryLength: action.payload.academicStoryLength}
    default:
      return state
  }
}